export const detectLanguageFromPath = (pathname = "") => {
  if (typeof pathname !== "string") {
    return "de";
  }

  if (pathname === "/en" || pathname.startsWith("/en/")) {
    return "en";
  }

  if (pathname === "/de" || pathname.startsWith("/de/")) {
    return "de";
  }

  return "de";
};
